module.exports = __webpack_public_path__ + "media/images/sample/ic_facebook-dc2fb85729c46d641027903f7373e6d0.png";